import React from 'react';
import { Cureus } from '../../Cureus';

const Card = ({channel, userId}) => {
  const handleClick = () => {
    new Cureus.Amplitude({
      event_type: 'clickChannelPage',
      channel_id: channel.id,
      channel_name: channel.title,
      source: window.location.pathname,
      from: 'list',
      user_id: userId
    });
  }

  return (
      <div className="small-12 medium-6 large-4 channel-card">
        <img src={channel.logo_url}/>
        <p>{channel.title}</p>
        <div className='hovered-content'>
          <a class="button large learn-more-button" href={channel.channel_path} onClick={handleClick}>LEARN MORE</a>
        </div>
      </div>
  )
}

export default Card;